import { motion } from "framer-motion";
import { Zap } from "lucide-react";

export const PromoBanner = ({ onClaim }) => (
  <motion.div
    data-testid="promo-banner"
    initial={{ opacity: 0, y: -20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 1.8, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
    className="relative z-40 mt-[70px] border-b border-nitro/40 bg-gradient-to-r from-nitro/20 via-nitro/10 to-nitro/20"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-3 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-center">
      <p className="font-mono text-[11px] sm:text-xs tracking-[0.25em] uppercase text-neutral-300 flex flex-wrap items-center justify-center gap-2">
        <Zap size={13} className="text-nitro" />
        Limited offer —
        <span className="text-nitro font-bold">50% off all services</span>
        with code
        <span className="text-neutral-100 font-bold bg-nitro/20 border border-nitro/50 rounded px-2 py-0.5 tracking-[0.2em]">
          BM50
        </span>
      </p>
      <button
        data-testid="promo-claim-button"
        onClick={onClaim}
        className="font-heading font-semibold uppercase tracking-widest text-xs bg-nitro hover:bg-[#ff4561] text-white rounded-full px-5 py-1.5 transition-all duration-300 hover:shadow-[0_0_20px_rgba(255,46,77,0.5)]"
      >
        Claim Offer
      </button>
    </div>
  </motion.div>
);
